import styled from 'styled-components'
import { Card } from 'vvs-uikit'

const StyledCardMini = styled(Card)`
  align-self: start;
  max-width: 330px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0 12px 46px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    max-width: 380px;
  }
`

export default StyledCardMini
